import React, {useEffect, useState} from 'react';
import {Article} from "types/Article";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    article: Article | null
    show: boolean
    onDelete?: (article: Article) => any
    onDeleteFail?: (article: Article, error: unknown) => any
    onCancel?: () => any
}

function DeleteArticle(props: Props) {
    const {article, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(article?.title || 'this article');
    const {mutateAsync: deleteArticle} = useMutation(ngage.articles.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(article) setName(article.title)
    }, [article]);

    async function handleDeleteArticle() {
        if (article) {
            try {
                await deleteArticle(article.id)
                await invalidate('articles.all')

                notify("success", "Article Deleted", `${article.title} has been permanently removed`)
                if (onDelete) onDelete(article)
            } catch (error) {
                notify("error", "Article Not Deleted", `${article.title} could not be removed`)
                if (onDeleteFail) onDeleteFail(article, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Article"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteArticle}
            onCancel={handleCancel}
        />
    );
}

export default DeleteArticle;